export default __webpack_public_path__ + "static/brcc-full-width-2-9d4af92bbacd74b96ae56df4db46746e.avif";